import { Controller } from "stimulus"

export default class extends Controller {
	static targets = ['zeroToBlank'];
  connect () {
  	this.zeroToBlank();
  }

  zeroToBlank () {
    this.zeroToBlankTargets.forEach( (target) => {
      switch (target.value) {
        case '0.0':
        case '0,0':
        case '0':
        case '':
        	// Removing the value makes us fallback to placeholder instead
          target.value = '';
      }
    } )
  }
}